import { createAction } from '@reduxjs/toolkit'

export const selectIndividualAction = createAction<string | undefined>(
  'settings/selectedIndividualId',
)

export const signOutAction = createAction('auth/signOut')
